import { Badge, Dropdown, Space, Tree } from "antd"
import cx from "clsx"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"
import { Button, Checkbox, Group, Icon, Text, TextInput, Title } from ".."
import styles from "./index.module.less"

export const TreeDropdown = props => {
  const { t } = useTranslation()
  const { data, disabled, onApplyFilter, labelKey = "label" } = props
  const [searchParams, setSearchParams] = useSearchParams()
  const queryObj = Object.fromEntries([...searchParams])
  const selectedColumns = queryObj?.filteredColumns?.split(",") || []

  const [searchValue, setSearchValue] = useState("")
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [selectedNodes, setSelectedNodes] = useState([])
  useEffect(() => {
    selectedColumns && setSelectedNodes(selectedColumns)
  }, [searchParams])

  const handleCheckItem = item => {
    const { checkedNodes, node } = item
    let keys = [...selectedNodes]
    const isChildAlreadyExist = keys?.indexOf(node.key)
    const isParentSelectedAlready = node?.children?.every(it => keys.includes(it.key)) || false
    if (isChildAlreadyExist === -1 && !isParentSelectedAlready) {
      checkedNodes.forEach(e => {
        if (keys?.indexOf(e?.key) === -1 && e.key !== item.node.parent && !e.children) {
          keys.push(e.key)
        } else if (e.children) {
          !e.children.find(it => it.key === item.node.key) &&
            e.children.forEach(it => keys?.indexOf(it?.key) === -1 && keys.push(it.key))
        }
      })
    } else {
      if (isParentSelectedAlready) {
        keys = keys.filter(element => !node.children.map(it => it.key).includes(element))
      } else {
        keys.splice(isChildAlreadyExist, 1)
      }
    }
    setSelectedNodes(keys)
  }

  const handleShowRows = () => {
    if (selectedNodes?.length > 0) {
      setSearchParams({ ...queryObj, filteredColumns: selectedNodes.map(item => item).join(",") })
    } else if (queryObj?.filteredColumns) {
      let copyQueryObj = { ...queryObj }
      delete copyQueryObj["filteredColumns"]
      setSearchParams({ ...copyQueryObj })
    }
    setDropdownVisible(!dropdownVisible)
  }

  const renderNodeTitle = node => {
    if (node?.children) {
      return (
        <Title level={3} className={styles.title}>
          {node?.[labelKey]}
        </Title>
      )
    }
    return (
      <Space size={4}>
        {node?.[labelKey]} {node.short && <Text type="secondaryLight">({node.short})</Text>}
      </Space>
    )
  }

  const handleClearAll = () => {
    setSelectedNodes([])
    if (queryObj?.filteredColumns) {
      let copyQueryObj = { ...queryObj }
      delete copyQueryObj["filteredColumns"]
      setSearchParams({ ...copyQueryObj })
    }
    setDropdownVisible(!dropdownVisible)
  }

  const getDataKeys = () => {
    let keys = []
    data?.map(node => {
      node?.children?.length > 0 &&
        node.children.map(child => {
          keys.push(child.key)
        })
    })
    return keys
  }

  const handleSelectAll = () => {
    if (selectedNodes.length == getDataKeys()?.length) {
      setSelectedNodes([])
    } else setSelectedNodes(getDataKeys())
  }

  const getCheckedState = () => {
    return getDataKeys().length == selectedNodes.length
  }

  const filteredData = data?.length
    ? data
        .map(node => {
          const matchesSearch =
            (node?.[labelKey] && node?.[labelKey]?.toLowerCase().includes(searchValue?.toLowerCase())) ||
            (node?.children &&
              node?.children?.some(child => child?.[labelKey]?.toLowerCase().includes(searchValue?.toLowerCase())))

          return matchesSearch
            ? {
                ...node,
                children: node?.children
                  ? node?.children?.filter(child => child?.[labelKey]?.toLowerCase().includes(searchValue?.toLowerCase()))
                  : [],
              }
            : null
        })
        .filter(Boolean)
    : []

  return (
    <Dropdown
      open={dropdownVisible}
      onOpenChange={visible => setDropdownVisible(visible)}
      disabled={disabled}
      width={300}
      trigger={["click"]}
      dropdownRender={() => (
        <div className={cx(styles.dropdownContent, "p-16")} style={{ width: 320 }}>
          <TextInput
            prefixIcon="FiSearch"
            iconColor="#9D9D9D"
            className="mbe-8 pb-8 "
            value={searchValue}
            onChange={e => setSearchValue(e.target.value)}
            placeholder={t("Search columns")}
            allowClear
            style={{ maxWidth: "295px" }}
          />
          <Checkbox checked={getCheckedState()} onChange={handleSelectAll} className={styles.selectAll}>
            {t("Select All")}
          </Checkbox>
          <div>
            <Tree
              className={cx(styles.dropdownTree, "mbe-8")}
              checkedKeys={selectedNodes}
              selectedKeys={selectedNodes}
              expandedKeys={data?.map(e => e.key)}
              selectable={false}
              checkable
              titleRender={node => {
                return renderNodeTitle(node)
              }}
              multiple
              treeData={filteredData}
              onCheck={(value, item) => handleCheckItem(item)}
              height={400}
              switcherIcon={() => <></>}
            />

            <Group template={"1fr 1fr"} gap="8px" className={styles.dropdownTreeFooter}>
              <Button
                bordered
                variant="skeleton"
                onClick={handleClearAll}
                disabled={!selectedNodes.length}
                text={t("Reset All")}
                className={styles.reset}
                block
                size="small"
              />
              <Button
                text={t("Show Results")}
                type="primary"
                size="small"
                onClick={() => {
                  handleShowRows()
                  onApplyFilter()
                }}
                block
              />
            </Group>
          </div>
        </div>
      )}
    >
      {selectedNodes.length ? (
        <Badge
          count={selectedNodes.length}
          offset={[4, 0]}
          size="small"
          status="success"
          className={styles.filterBadge}
        >
          <Icon icon="MdFilterList" size="25px" />
        </Badge>
      ) : (
        <Icon icon="MdFilterList" size="25px" />
      )}
    </Dropdown>
  )
}

TreeDropdown.propTypes = {
  onApplyFilter: PropTypes.func,
}

TreeDropdown.defaultProps = {
  onApplyFilter: () => {},
}
